<template>
    <div class="search-teams">
        <search-teams-form @receive-data="setTeamsData" @reset-data="handleReset" :skip="skip" :limit="limit" />

        <team-preview-list :teams="teamArray" :total="total" :with-card="true" :limit="limit"
            :current-page="currentPage" :on-navigate="onNavigate" />

    </div>
</template>

<script>
import TeamPreviewList from '@/components/teams/TeamPreviewList.vue';
import SearchTeamsForm from '@/components/teams/SearchTeamsForm.vue';

export default {
    name: 'SearchTeams',
    components: {
        TeamPreviewList,
        SearchTeamsForm,
    },
    data() {
        return {
            teamArray: [],
            total: null,
            limit: 20,
            currentPage: 1,
            teamToJoin: null,
        };
    },
    computed: {
        skip() {
            const { currentPage, limit } = this;
            return (currentPage - 1) * limit;
        },
    },
    methods: {
        setTeamsData(data) {
            this.teamArray = data.items;
            this.total = data.totalCount;
        },
        onNavigate(nextPage) {
            this.currentPage = nextPage;
        },
        handleReset() {
            this.teamArray = [];
            this.total = null;
        },
    },
};
</script>

<style lang="scss">
.search-teams {
    &__heading {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
    }

    &__title {
        margin: 0;
        margin-bottom: var(--global-dimension-size-250);
        font-weight: 500;
        font-size: var(--font-size-800);
    }

    &__list {}

    &__item {}

    &__empty-text {}
}
</style>
